import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { getMailroomConfigs, getMergeFieldsConfig } from '../api/suggestionService';

export const useTemplateConfigs = () => {
    const [mailroomConfigs, setMailroomConfigs] = useState([]);
    const [isLoadingConfigs, setIsLoadingConfigs] = useState(false);
    const [mergeFieldsConfig, setMergeFieldsConfig] = useState([]);
    const [templateData, setTemplateData] = useState([]);
    const [loadingTemplateFields, setLoadingTemplateFields] = useState(false);
    const [loadingEmailSubject, setLoadingEmailSubject] = useState(false);
    const [replaceFields, setReplaceFields] = useState([]);
    const [templateValidationMessage, setTemplateValidationMessage] = useState('');
    const [showTemplatePreview, setShowTemplatePreview] = useState(false);
    const [previewTemplates, setPreviewTemplates] = useState([]);
    const [highlightField, setHighlightField] = useState('');

    useEffect(() => {
        async function fetchConfigs() {
            setIsLoadingConfigs(true);
            try {
                const configs = await getMailroomConfigs();
                setMailroomConfigs(configs || []);
            } catch (error) {
                console.error('Error fetching mailroom configurations:', error);
                toast.error('Failed to load sending options. Please try again later.');
            } finally {
                setIsLoadingConfigs(false);
            }
        }

        async function fetchMergeFieldsConfiguration() {
            try {
                const config = await getMergeFieldsConfig();
                setMergeFieldsConfig(config || []);
            } catch (error) {
                console.error('Error fetching merge fields configuration:', error);
            }
        }

        fetchConfigs();
        fetchMergeFieldsConfiguration();
    }, []);

    // Function to handle template preview
    const handleTemplatePreview = (fieldName) => {
        // Determine which fields to highlight based on the field name
        let fieldsToHighlight = [];

        // Check if fieldName is an array (passed from DynamicMergeFields for datetime fields)
        if (Array.isArray(fieldName)) {
            fieldsToHighlight = fieldName;
        } else if (fieldName === 'zoom_meeting_id') {
            // For zoom settings, highlight both zoom_meeting_id and zoom_meeting_password
            fieldsToHighlight = ['zoom_meeting_id', 'zoom_meeting_password'];
        } else {
            // For other fields, highlight just the single field
            fieldsToHighlight = [fieldName];
        }

        setHighlightField(fieldsToHighlight);

        // Filter templates based on field type
        let filteredTemplates = [];

        if (fieldName === 'smsdatereminder') {
            // For SMS date reminder, show only SMS templates
            filteredTemplates = templateData.filter(template => template.type === 'sms');
        } else if (fieldName === 'sendTo') {
            // For Send To field, show all templates (email, email_reminder, and SMS)
            filteredTemplates = templateData;
        } else {
            // For all other fields, show only email and email_reminder templates (exclude SMS)
            filteredTemplates = templateData.filter(template =>
                template.type === 'email' || template.type === 'email_reminder'
            );
        }

        console.log(`Field: ${fieldName}, Fields to highlight:`, fieldsToHighlight, 'Filtered templates:', filteredTemplates);

        setPreviewTemplates(filteredTemplates);
        setShowTemplatePreview(true);
    };

    const handleCloseTemplatePreview = () => {
        setShowTemplatePreview(false);
        setHighlightField('');
        setPreviewTemplates([]);
    };

    return {
        mailroomConfigs, setMailroomConfigs,
        isLoadingConfigs, setIsLoadingConfigs,
        mergeFieldsConfig, setMergeFieldsConfig,
        templateData, setTemplateData,
        loadingTemplateFields, setLoadingTemplateFields,
        loadingEmailSubject, setLoadingEmailSubject,
        replaceFields, setReplaceFields,
        templateValidationMessage, setTemplateValidationMessage,
        showTemplatePreview, setShowTemplatePreview,
        previewTemplates, setPreviewTemplates,
        highlightField, setHighlightField,
        handleTemplatePreview, handleCloseTemplatePreview
    };
};
